module.exports = __webpack_public_path__ + "img/6c28134.png";